import { render, staticRenderFns } from "./ExperimentalTeam.vue?vue&type=template&id=564e22d0&scoped=true&"
import script from "./ExperimentalTeam.vue?vue&type=script&lang=js&"
export * from "./ExperimentalTeam.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/table.css?vue&type=style&index=0&id=564e22d0&scoped=true&lang=css&"
import style1 from "./ExperimentalTeam.vue?vue&type=style&index=1&id=564e22d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564e22d0",
  null
  
)

export default component.exports